import React, { Component, Fragment } from 'react';
import { Bar } from 'react-chartjs-2';
import Title from './FileTitle';
class ChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        labels: [],
        datasets: []
      },
      yAxisLabel: 'Count',
      Graph_data:this.props.Graph_data
    };
  }

  componentDidMount() {
    const data  = this.props.Graph_data;
console.log("chart data: "+ JSON.stringify(this.state.Graph_data))
    // Extracting dynamic keys for network, severity, and count
    const keys = Object.keys(data[0]);

    // Assume the last key is the count, and the rest are labels
    const labels = keys.slice(0, -1);
    const countKey = keys[keys.length - 1];

    const labelValues = {};
    const datasets = {};
    const colors = {};

    data.forEach((item, index) => {
      const label = labels.map(label => item[label]).join(' - ');

      if (!labelValues[label]) {
        labelValues[label] = new Array(labels.length).fill(null).map((_, i) => item[labels[i]]);
        const color = this.getRandomColor();
        datasets[label] = {
          label,
          data: new Array(data.length).fill(0),
          backgroundColor: color,
          borderColor: color,
          borderWidth: 1
        };
        colors[label] = color;
      }

      datasets[label].data[index] = item[countKey];
    });

    this.setState({
      data: {
        labels: Object.keys(labelValues),
        datasets: Object.values(datasets)
      },
      colors
    });
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    return (
      <Fragment>
         <b><Title name={"Charts" } /> </b>
         {this.state.Graph_data &&
      <div style={{ width: 'auto', height: 'auto' }}>
        {/* <h2>Dynamic Chart</h2> */}
        <Bar 
          data={this.state.data}
          options={{
            scales: {
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: this.state.yAxisLabel
                }
              }]
            }
          }}
        />
      </div>
  }
      </Fragment>
        
    );
  }
}

export default ChartComponent;
